import {

  GET_SETTINGS,
  GET_SETTINGS_FAIL,
  GET_SETTINGS_SUCCESS,

  UPDATE_SETTING,
  UPDATE_SETTING_SUCCESS,
  UPDATE_SETTING_FAIL,

} from "./actionTypes"

export const getSettings = () => ({
  type: GET_SETTINGS,
})

export const getSettingsSuccess = settings => ({
  type: GET_SETTINGS_SUCCESS,
  payload: settings,
})

export const getSettingsFail = error => ({
  type: GET_SETTINGS_FAIL,
  payload: error,
})

export const updateSetting = (setting,history) => ({
  type: UPDATE_SETTING,
  payload: {setting,history},
})

export const updateSettingSuccess = user => ({
  type: UPDATE_SETTING_SUCCESS,
  payload: user,
})

export const updateSettingFail = error => ({
  type: UPDATE_SETTING_FAIL,
  payload: error,
})


